import { getTagData } from "api/tags";

const showTicketModalConfig = {
  getTagData
};

export default showTicketModalConfig;